import {
    GET_WAGON_RECIPES_LOADING,
    GET_WAGON_RECIPES_SUCCESS,
    GET_WAGON_RECIPES_FAILURE
} from '../actionTypes'
import store from '../store';
import { showUnknownError } from './keyboard-shortcuts.actions';
import { client } from '../../services/client';
import { getRecursivelyAsync } from '../../utils/get-recursively-async';

export const getWagonRecipesSuccess = payload => ({
    type: GET_WAGON_RECIPES_SUCCESS,
    payload
})

export const getWagonRecipesFailure = () => ({
    type: GET_WAGON_RECIPES_FAILURE
})

export const getWagonRecipesAsync = payload => dispatch => {
    return dispatch(getRecursivelyAsync('wagon-recipes', getWagonRecipesSuccess, 0));
}